import { gql } from '@apollo/client';
import { client } from 'graphql/client';

const EXCHANGE_SUPPORT_LOGIN_SHORT_CODE = gql`
  mutation ExchangeSupportLoginShortCode($phone: Long!, $shortCode: String!) {
    exchangeSupportLoginShortCode(phone: $phone, shortCode: $shortCode) {
      success
      message
      token
      deviceId
      account {
        id
        name
        phone
        avatarUrl
        role {
          name
          permissions
        }
      }
    }
  }
`;

interface ExchangeSupportLoginShortCodeResponse {
    exchangeSupportLoginShortCode: {
        success: boolean;
        message?: string | null;
        token?: string | null;
        deviceId?: string | null;
        account?: {
            id: string;
            name: string;
            phone?: string;
            avatarUrl?: string;
            role: {
                name: string;
                permissions: string[];
            };
        } | null;
    };
}

interface ExchangeSupportLoginShortCodeVariables {
    phone: number;
    shortCode: string;
}

export const exchangeSupportLoginShortCode = async (
    phone: number,
    shortCode: string
): Promise<ExchangeSupportLoginShortCodeResponse['exchangeSupportLoginShortCode'] | undefined> => {
    const { data } = await client.mutate<ExchangeSupportLoginShortCodeResponse, ExchangeSupportLoginShortCodeVariables>({
        mutation: EXCHANGE_SUPPORT_LOGIN_SHORT_CODE,
        variables: { phone, shortCode },
    });
    return data?.exchangeSupportLoginShortCode;
};
